// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.
import { useDashboardsManager } from './DashboardsManagerHook';

const DashboardsManager = () => {
  useDashboardsManager();
  return null;
};

export default DashboardsManager;
